import React, {useContext, useEffect, useState} from "react";
import {Link, useLocation} from 'react-router-dom';
import './ConsultaDisponibilidad.css';
import {ConsultaDisponibilidadSidebarResposnse} from './ConsultaDisponibilidadSidebarResposnse';
import RegistroDominioService from "../../services/RegistroDominioService";
import {TipoItemCarrito, TipoMensaje} from "../../store/AppProvider";
import AppContext from "../../store/AppContext";

export const ConsultaDisponibilidadContentResponse = (props) => {
    const appCtx = useContext(AppContext);
    const location = useLocation();
    const [preSeleccionDominios, setPreSeleccionDominios] = useState([]);
    const [agregandoAlCarrito, setAgregandoAlCarrito] = useState(false);

    const extensionDesdeNombre = (nombreDominio) => {
        const m = nombreDominio.match(/[.].*/);
        return m ? m[0] : '';
    };

    const aniosPorDefecto = (aniosContratacion) => {
        if (Array.isArray(aniosContratacion) && aniosContratacion.length > 0) {
            return aniosContratacion.includes(1) ? 1 : aniosContratacion[0];
        }
        return 1;
    };

    useEffect(() => {
        const resultadoDominios = props.resultadoDominios || [];
        const extensionesUnicas = [...new Set(resultadoDominios.map((d) => extensionDesdeNombre(d.nombreDominio)))];
        const porExtension = new Map();

        Promise.all(extensionesUnicas.map((ext) => RegistroDominioService.obtenerTarifas(ext))).then((responses) => {
            extensionesUnicas.forEach((ext, idx) => porExtension.set(ext, responses[idx]));
            const arrayPreSel = [];
            for (let index = 0; index < resultadoDominios.length; index++) {
                const ext = extensionDesdeNombre(resultadoDominios[index].nombreDominio);
                const tarifa = porExtension.get(ext);
                if (tarifa && tarifa.codigo === 'OK') {
                    const aniosContratacion = tarifa.aniosContratacion || [1];
                    arrayPreSel.push({
                        seleccionado: resultadoDominios[index].disponible,
                        disponible: resultadoDominios[index].disponible,
                        reservado: resultadoDominios[index].reservado,
                        nombre: resultadoDominios[index].nombreDominio,
                        anios: aniosPorDefecto(aniosContratacion),
                        aniosContratacion: aniosContratacion,
                        precio: +tarifa.precioUnitario
                    });
                }
            }
            setPreSeleccionDominios(arrayPreSel);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.resultadoDominios, location]);

    const handleClickCheck = (e) => {
        let nombreDominio = e.target.value;
        let editarPreSeleccion;

        editarPreSeleccion = modificarSeleccionados(nombreDominio, e.target.checked);
        setPreSeleccionDominios(editarPreSeleccion);
    }

    const modificarSeleccionados = (dominioNombre, chequeado) => {
        return preSeleccionDominios.map(dominio => {
            if (dominio.nombre === dominioNombre) {
                dominio.seleccionado = chequeado;
            }
            return dominio;
        });
    }

    const handleChangeAnios = (nombreDominio, anios) => {
        setPreSeleccionDominios(preSeleccionDominios.map(dominio => {
            if (dominio.nombre === nombreDominio) {
                return {...dominio, anios: Number(anios)};
            }
            return dominio;
        }));
    }

    const agregarAlCarrito = () => {
        // Si ya se está agregando al carrito, no permitimos mas clics
        if (agregandoAlCarrito) return;

        // Desactivar el boton para evitar clics múltiples
        setAgregandoAlCarrito(true);

        const registrosPendientes = appCtx.carrito.registrosPendientes;

        if (registrosPendientes == null || registrosPendientes.length < 10) {
            let registrarDominios = [];

            preSeleccionDominios.forEach((dominio) => {
                if (dominio.seleccionado && !registrosPendientes.some((elem) => elem.nombre === dominio.nombre)) {
                    registrarDominios.push({ "nombre": dominio.nombre, "anios": dominio.anios });
                }
            });

            if (registrarDominios.length > 0) {
                RegistroDominioService.agregarRegistroDominio(registrarDominios, appCtx.venta)
                    .then((response) => {
                        if (response.respuestaOK) {
                            response.dominiosOK.forEach((dominioNuevo) => {
                                const dominioActual = response.ventaDTO.items.find((item) => item.dominio.nombre === dominioNuevo.dominio.nombre);
                                const aniosItem = dominioActual.anios || dominioActual.cantidad || 1;
                                appCtx.agregarItemCarrito({
                                    id: dominioActual.dominio.id,
                                    nombre: dominioActual.dominio.nombre,
                                    precio: dominioActual.precioUnitario,
                                    anios: aniosItem
                                }, TipoItemCarrito.registro, null);
                            });
                            appCtx.setVenta({ idVenta: response.ventaDTO.ventaId, uuidVenta: response.ventaDTO.uuidVenta });
                        } else {
                            appCtx.mostrarMensaje(response.mensaje, TipoMensaje.error);
                        }
                    }).catch(() => {
                    console.log("Error agregando registro de dominio");
                }).finally(() => {
                    setAgregandoAlCarrito(false);
                });
            } else {
                setAgregandoAlCarrito(false);
            }
        } else {
            setAgregandoAlCarrito(false);
        }
    }

    return <>
        {/*contenido*/}
        <div id="content" className="fluid">
            <div className="inner-block">
                {/*caja  mensajes*/}
                <div className="box">

                    <div className="box-content domain-register cfx">
                        {props.dominioBuscadoDisponible ?
                            <h3 className="ok">Dominio disponible</h3> : <h3 className="no-ok">Dominio no disponible</h3>
                        }

                        <form id="id-form-register-domains">
                            <table className="register">
                                <tbody>
                                {  preSeleccionDominios && preSeleccionDominios.map((dominio, index) => (
                                    dominio.disponible?
                                    <tr key={index}>
                                        <th>
                                            <div>
                                                <input value={dominio.nombre} className={"checkbox-space"} type="checkbox"
                                                       checked={dominio.seleccionado} onChange={handleClickCheck}/>
                                                <span>{dominio.nombre}</span>
                                            </div>
                                        </th>

                                        <td>
                                            <select name="anios-dominio" id={`id-anios-dominio-${index}`}
                                                    value={dominio.anios}
                                                    onChange={(e) => handleChangeAnios(dominio.nombre, e.target.value)}>
                                                {(dominio.aniosContratacion || [1]).map((anio) => (
                                                    <option key={anio} value={anio}>
                                                        {anio} {anio > 1 ? 'años' : 'año'}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                        <td className="price">$ { dominio.precio * dominio.anios }</td>
                                    </tr> :
                                    <tr className="no-free" key={index}>
                                        <td>
                                            <div>
                                                <input value={dominio.nombre} className={"checkbox-space"} type="checkbox" defaultChecked={dominio.seleccionado} disabled={true}/>
                                                <span>{dominio.nombre}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <Link to="/consulta-whois" state={{dominioDisponibilidad: dominio.nombre}}>Consultar Whois</Link>
                                        </td>
                                        { dominio.reservado ?
                                            <td>
                                                Reservado
                                            </td> :
                                            <></>
                                        }
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            <hr/>

                    </form>
                    <div className="right">
                        <button id="btn-submit" className={"btn"} onClick={agregarAlCarrito}
                                disabled={agregandoAlCarrito}>
                            {agregandoAlCarrito ? 'Agregando...' : 'Agregar al carrito de compras'}
                        </button>

                    </div>
                    </div>

                </div>
                {/*fin caja*/}
            </div>
        </div>

        <ConsultaDisponibilidadSidebarResposnse />
    </>
}
